<template>
  <div>
    <router-link :to="{name: 'product-create' }" class="button is-primary is-pulled-right">
      Add product
    </router-link>
    <data-table :data-set="sortedProducts" :page-length="250" :columns="[
            {name: 'i', type: 'text', prop: 'sku', searchable: false},
            {name: 'SKU', type: 'text', prop: 'sku'},
            {name: 'Name', type: 'text', prop: 'name'},
            {name: 'COM', type: 'text', prop: 'company'},
            {name: 'Price', type: 'number', prop: 'price'},
            {name: 'Shipping', type: 'number', prop: 'shipping'},
            {name: 'Ship Months', sort: false, type: 'text', prop: 'ship_months'},
            {name: 'Active', type: 'text', prop: 'listed'},
            {name: 'Updated', type: 'text', prop: 'updated_at'},
        ]">
      <template slot="column_i" slot-scope="props">
        <div class="data-images">
          <router-link :to="{name: 'product', params:{id:props.row.id}}" tabindex="-1">
            <img v-for="image in props.row.images" :src="image.thumbnail_path" class="data-image"/>
          </router-link>
        </div>
      </template>
      <template slot="column_Name" slot-scope="props">
        <router-link :to="{name: 'product', params:{id:props.row.id}}" tabindex="-1">
          {{ props.row.short_name | limit(40) }}
        </router-link>
      </template>
      <template slot="column_Price" slot-scope="props">
        <div class="has-text-right">
          $<input type="text" class="input incognito-input auto-size-input" :value="props.row.price"
                  :id="'plist_price_pid_'+props.row.id">
        </div>
      </template>
      <template slot="column_Shipping" slot-scope="props">
        <div class="has-text-right" v-if="props.row.shipping == null">
          <small><em>OVERRIDDEN</em></small>
        </div>
        <div class="has-text-right text-nowrap" v-else>
          $<input type="text" class="input incognito-input auto-size-input" :value="props.row.shipping"
                  :id="'plist_shipping_pid_'+props.row.id">
        </div>
      </template>
      <template slot="column_Ship Months" slot-scope="props">
        <div class="has-text-centered" v-if="props.row.ship_months == null">
          WARNING
        </div>
        <div class="ship_month_indicator" v-else>
          <div v-for="month in expandMonths(props.row.ship_months)"
               :class="{'ship_month_display': true, 'ship_month_active': month.active}"
               @click="toggleShipMonth(props.row, month)">
            {{ month.initial }}
          </div>
        </div>
      </template>
      <template slot="column_Active" slot-scope="props">
        <label class="checkbox" @click="toggleActiveProduct(props.row)">
          <input type="checkbox" :checked="props.row.listed">
        </label>
      </template>

      <template slot="column_Updated" slot-scope="props">
        {{ props.row.updated_at | moment('from') }}
      </template>
      <template slot="controls" slot-scope="props">
        <td>
          <div class="has-text-right">
            <a class="delete" @click="deleteProduct(props.row)"></a>
          </div>
        </td>
      </template>
    </data-table>
    <div class="has-text-right">
      <button class="button is-success" @click="updatePrices()">
        Update Prices
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.ship_month_indicator {
  display: inline-block;
  white-space: nowrap;
  font-size: 0;
  padding: 0;
  margin: 0;
  color: #FFF;
  background-color: #CCC;
  border-radius: 2px;
  text-align: center;
}

.ship_month_display {
  display: inline-block;
  font-size: 12px;
  padding: 0 2px;

  &:hover {
    cursor: pointer;
  }

  &.ship_month_active {
    background-color: #68912c;
    color: #fff;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import {
  DELETE_PRODUCT,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_LISTED,
  UPDATE_PRODUCT_PRICING,
} from "../../../store/mutation-types";
import sortAlphaNum from "../../../utils/sortAlphaNum"

export default {
  name: 'product-list',
  data() {
    return {
      months: [
        { number: 1, order: 5, name: 'Jan', initial: 'J', active: false },
        { number: 2, order: 6, name: 'Feb', initial: 'F', active: false },
        { number: 3, order: 7, name: 'Mar', initial: 'M', active: false },
        { number: 4, order: 8, name: 'Apr', initial: 'A', active: false },
        { number: 5, order: 9, name: 'May', initial: 'M', active: false },
        { number: 6, order: 10, name: 'Jun', initial: 'J', active: false },
        { number: 7, order: 11, name: 'Jul', initial: 'J', active: false },
        { number: 8, order: 12, name: 'Aug', initial: 'A', active: false },
        { number: 9, order: 1, name: 'Sep', initial: 'S', active: false },
        { number: 10, order: 2, name: 'Oct', initial: 'O', active: false },
        { number: 11, order: 3, name: 'Nov', initial: 'N', active: false },
        { number: 12, order: 4, name: 'Dec', initial: 'D', active: false },
      ],
      updateQueue: [],
      updateTimer: 0,
    }
  },
  computed: Object.assign({}, mapGetters(['products', 'imageables', 'images']), {
    sortedProducts() {
      return this.products
                 .map(p => {
                   const imls = this.imageables.filter(iml => {
                     return iml.imageable_type === 'Product' && iml.imageable_id === p.id
                   })
                   return {
                     ...p,
                     images: this.images.filter(i => {
                       return imls.filter(iml => i.id === iml.image_id).length > 0;
                     }),
                   };
                 })
                 .sort((a, b) => a.sku.localeCompare(b.sku))
    },
  }),
  methods: {
    translateMonth(month) {
      let m = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec',
      }
      return m[month];
    },
    expandMonths(ship_months) {
      let m = JSON.parse(JSON.stringify(this.months))
      for (let x = 0; x < ship_months.length; x++) {
        let i       = m.indexOf(m.find(l => l.number === ship_months[x]));
        m[i].active = true;
      }
      return m.sort((a, b) => a.order - b.order);
    },
    toggleShipMonth(product, month) {
      clearTimeout(this.updateTimer);
      let p = JSON.parse(JSON.stringify(product));

      let existing_p = this.updateQueue.find(l => l.id === p.id);
      if (existing_p !== undefined) {
        p = JSON.parse(JSON.stringify(existing_p));
        this.updateQueue.splice(this.updateQueue.indexOf(existing_p), 1);
      }

      let selectedMonths     = p.ship_months;
      let selectedMonthIndex = p.ship_months.indexOf(month.number);
      if (selectedMonthIndex === -1) {
        selectedMonths.push(month.number);
      }
      else {
        selectedMonths.splice(selectedMonthIndex, 1);
      }

      selectedMonths = selectedMonths.sort((a, b) => {
        let aMonth = this.months.find(month => month.number === a)
        let bMonth = this.months.find(month => month.number === b)
        return aMonth.order - bMonth.order
      })

      p.ship_months = selectedMonths;

      this.updateQueue.push(p);

      this.updateTimer = setTimeout(() => {

        for (let x = 0; x < this.updateQueue.length; x++) {

          let pu = this.updateQueue[x];

          this.$store.dispatch(UPDATE_PRODUCT, { fields: pu, showload: false })
              .then(d => {
                this.updateQueue.splice(this.updateQueue.indexOf(this.updateQueue.find(i => i.id === pu.id)), 1);
              })
              .catch(e => {
                this.updateQueue.splice(this.updateQueue.indexOf(this.updateQueue.find(i => i.id === pu.id)), 1);
              });
        }
      }, 1000);

    },
    toggleActiveProduct(product) {
      this.$store.dispatch(UPDATE_PRODUCT_LISTED,
        {
          fields: {
            id: product.id,
            listed: !product.listed,
          },
          showload: false,
        },
      );
    },
    deleteProduct(product) {
      if (window.confirm("Are you sure?")) {
        this.$store.dispatch(DELETE_PRODUCT, product)
      }
    },
    updatePrices() {
      let pricesNodeList      = document.querySelectorAll('[id*="plist_price_pid_"]');
      let shippingNodeList    = document.querySelectorAll('[id*="plist_shipping_pid_"]');
      let potentialUpdateList = [];
      pricesNodeList.forEach(input => {
        let id = parseInt(input.getAttribute('id').substr(16, input.getAttribute('id').length));
        potentialUpdateList.push({ 'id': id, 'price': parseFloat(input.value), 'shipping': null });
      });
      shippingNodeList.forEach(input => {
        let id                  = parseInt(input.getAttribute('id')
                                                .substr(19, input.getAttribute('id').length));
        let existingRecord      = potentialUpdateList.find(input => input.id === id)
        let existingIndex       = potentialUpdateList.indexOf(existingRecord);
        existingRecord.shipping = input.value.length > 0 ? parseFloat(input.value) : null;

        potentialUpdateList.splice(existingIndex, 1, existingRecord);
      });

      let updates = [];
      for (let x = 0; x < potentialUpdateList.length; x++) {
        let potentialUpdate = potentialUpdateList[x];
        let existingProduct = this.products.find(product => product.id === potentialUpdate.id);
        let priceSame       = true;
        let shippingSame    = true;
        if (parseFloat(existingProduct.price) !== potentialUpdate.price) {
          priceSame = false;
        }
        if (existingProduct.shipping === null) {
          if (potentialUpdate.shipping !== null) {
            shippingSame = false;
          }
        }
        else {
          if (parseFloat(existingProduct.shipping) !== potentialUpdate.shipping) {
            shippingSame = false;
          }
        }

        if (!priceSame || !shippingSame) {
          updates.push(potentialUpdate);
        }
      }

      this.$store.dispatch(UPDATE_PRODUCT_PRICING, updates);
    },
  },
}
</script>



// WEBPACK FOOTER //
// ProductList.vue?6414a537